import css from 'styled-jsx/css';
import { pageWidth } from 'styles/css-constants';
import { fontScale2 } from 'styles/typography/css-mixins';

/*
The List is designed to work with two other Column or List bundles (or one other ListWide bundle) to form three, centered columns of teasers
*/
export default css`
  .Spread--listWide {
    flex-direction: column;
    padding: 0 0.5rem;
  }

  .Spread__cake {
    flex-wrap: wrap;
    flex: 0 0 100%;
    max-width: 100%;
  }

  .Spread__item--teaser {
    margin-bottom: 1.5rem;
  }

  .Spread__title {
    width: 100%;
    margin-right: 0;
    margin-left: 0;
  }

  .Spread__items {
    flex-direction: column;
  }

  @media (max-width: 63.99rem) {
    .Spread__cake-name img {
      max-width: 100px;
    }
  }

  @media (min-width: 48rem) {
    .Spread--listWide {
      position: relative;
      display: flex;
      padding: 0;
    }

    .Spread__description,
    .Spread__title {
      margin-right: 0;
      margin-left: 0;
    }

    .Spread__title {
      margin-bottom: 0.5rem;
      align-items: flex-end;
      border-bottom: none;
    }

    .Spread__title h4 {
      color: #000;
      font-size ${fontScale2};
      font-weight: 400;
      letter-spacing: 0.15em;
    }
  }

  @media (min-width: 64rem) {
    .Spread--listWide {
      padding: 0;
    }

    .Spread__item--ad:last-child .Ad:not(.Ad--empty) {
      padding: 2rem 0 0;
    }

    .Spread__item--teaser {
      flex: 0 0 auto;
    }

    .Spread__title {
      position: static;
      margin: 0 auto 0.5rem;
      display: block;
      width: ${pageWidth.large};
    }
  }

  @media (min-width: 75rem) {
    .Spread__title {
      margin: 0 auto;
      width: ${pageWidth.midlarge};
    }

    .Spread--1 .Spread--item--teaser:nth-child(1) {
      margin-bottom: 0;
    }

    .Spread--2 .Spread--item--teaser:nth-child(2) {
      margin-bottom: 0;
    }

    .Spread--3 .Spread--item--teaser:nth-child(3) {
      margin-bottom: 0;
    }

    .Spread--4 .Spread--item--teaser:nth-child(4) {
      margin-bottom: 0;
    }

    .Spread--5 .Spread--item--teaser:nth-child(5) {
      margin-bottom: 0;
    }

    .Spread--6 .Spread--item--teaser:nth-child(6) {
      margin-bottom: 0;
    }

    .Spread--7 .Spread--item--teaser:nth-child(7) {
      margin-bottom: 0;
    }

    .Spread--8 .Spread--item--teaser:nth-child(8) {
      margin-bottom: 0;
    }

    .Spread--9 .Spread--item--teaser:nth-child(9) {
      margin-bottom: 0;
    }

    .Spread--10 .Spread--item--teaser:nth-child(10) {
      margin-bottom: 0;
    }

    .Spread--11 .Spread--item--teaser:nth-child(11) {
      margin-bottom: 0;
    }

    .Spread--12 .Spread--item--teaser:nth-child(12) {
      margin-bottom: 0;
    }
  }

  @supports (display: grid) {
    @media (min-width: 64rem) {
      .Spread__item--ad {
        grid-column: span 3;
      }

      .Spread__item--ad:last-child {
        display: block;
      }

      .Spread__item--teaser {
        grid-column: 2 / 3;
      }

      .Spread__items {
        display: grid;
        grid-template-columns: 1fr ${pageWidth.large} 1fr;
        grid-row-gap: 0;
      }
    }

    @media (min-width: 75rem) {
      .Spread__items {
        grid-template-columns: 1fr ${pageWidth.midlarge} 1fr;
      }
    }
  }
`;
